export const kiosk = {
  seo: {
    title: 'Borne de commande pour restaurants | Bistroo',
    description: "La borne Bistroo permet aux clients de commander de façon autonome sur place. Moins d'attente, plus de chiffre d'affaires. Renseignez-vous sur les possibilités.",
  },
  hero: {
    title: {
      pt1: 'Une',
      pt2: 'borne de commande',
      pt3: 'qui fait croître votre chiffre d\'affaires en pilote automatique',
    },
    description:
      'Le Bistroo Kiosk permet aux clients de commander à leur propre rythme, libérant ainsi votre personnel pour ce qui compte vraiment. Plus de commandes, des valeurs de commande plus élevées et des files d\'attente plus courtes sans effort supplémentaire.',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Plus de chiffre d\'affaires, moins d\'attente',
      text: 'Une borne libre-service augmente la valeur moyenne des commandes jusqu\'à 25 %, car les clients prennent le temps de commander et sont plus enclins à accepter les suggestions d\'upsell. En même temps, votre équipe traite plus de commandes en moins de temps, sans personnel supplémentaire à la caisse.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_2: {
      title: 'Design interactif à votre propre charte graphique',
      text: 'Personnalisez entièrement la borne aux couleurs et à l\'image de votre marque. De l\'écran d\'accueil à la confirmation de commande, tout s\'harmonise parfaitement avec la charte graphique de votre restaurant. Ainsi, le Bistroo Kiosk devient un véritable élément accrocheur qui s\'intègre parfaitement dans votre concept.',
      cta: '',
    },
    paragraph_3: {
      title: 'Commander rapidement, clairement et de manière organisée',
      text: 'Chaque commande via le Bistroo Kiosk reçoit automatiquement un numéro de commande et un ticket, ce qui facilite le retrait pour les clients et la gestion pour le personnel. Une expérience de commande fluide aussi bien pour les établissements individuels que pour les chaînes.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_4: {
      title: 'Gestion complète via le Bistroo Manager',
      text: 'La dernière chose que vous souhaitez en tant que propriétaire de restaurant ou de boutique alimentaire, c\'est devoir appeler quelqu\'un pour modifier votre menu. Nous vous donnons le contrôle total sur vos données, produits, clients et commandes !',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Commander en autonomie, moins de pression à la caisse.',
        text: 'Les clients commandent à leur propre rythme via l\'écran tactile. Votre personnel dispose de plus de temps pour le service, la préparation et la qualité.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Intégrations.',
        text: 'Connectez facilement la borne à votre système de caisse, à votre écran cuisine ou à d\'autres outils.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Upselling intelligent.',
        text: 'Configurez des suggestions automatiques à chaque commande et augmentez la valeur moyenne des commandes sans effort.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Augmentation du chiffre d\'affaires.',
        text: 'Les restaurants constatent en moyenne jusqu\'à 25 % de chiffre d\'affaires supplémentaire après l\'introduction d\'une borne de commande.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Promotions et fidélité.',
        text: 'Configurez des remises, des offres et des récompenses de fidélité directement visibles sur la borne.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Depuis l\'introduction du Bistroo Kiosk, les files d\'attente sont nettement plus courtes et les clients commandent plus qu\'auparavant. Notre personnel a enfin le temps de se consacrer à la véritable hospitalité."',
    cta: 'Lire l\'histoire complète',
    name: 'Thomas Hendriks',
    job_title: 'Propriétaire La Bella Cucina',
  },
  faq: {
    title_pt1: 'Tout sur le',
    title_pt2: 'Bistroo Kiosk',
    items: [
      { q: 'Qu\'est-ce que le Bistroo Kiosk et à qui s\'adresse-t-il ?', a: 'Le Bistroo Kiosk est une borne de commande libre-service pour les restaurants, les boutiques alimentaires et les chaînes de restauration. Les clients commandent de façon autonome via un écran tactile, ce qui réduit les files d\'attente et augmente la valeur moyenne des commandes.' },
      { q: 'Comment installer la borne de commande ?', a: 'La borne est plug-and-play. Après la livraison, vous l\'allumez, la connectez à votre Wi-Fi et elle est prête à l\'emploi. Bistroo vous accompagne lors de la configuration initiale et du raccordement à vos systèmes existants.' },
      { q: 'Puis-je personnaliser la borne à ma propre charte graphique ?', a: 'Absolument. Vous personnalisez entièrement l\'écran d\'accueil, les couleurs et l\'image de marque. De la première image à la confirmation de commande, tout s\'harmonise parfaitement avec la charte graphique de votre restaurant.' },
      { q: 'Comment les commandes de la borne sont-elles traitées ?', a: 'Chaque commande de la borne reçoit automatiquement un numéro de commande et un ticket. La commande est immédiatement transmise à l\'imprimante cuisine ou au système de caisse, comme une commande en ligne ordinaire.' },
      { q: 'Quels modes de paiement la borne prend-elle en charge ?', a: 'Le Bistroo Kiosk prend en charge le paiement par carte (sans contact et puce) et les méthodes de paiement mobiles comme Apple Pay et Google Pay. Le paiement en espèces est optionnel selon votre configuration.' },
      { q: 'Comment fonctionne l\'upselling sur la borne ?', a: 'Vous configurez des suggestions automatiques par produit ou catégorie dans le Bistroo Manager. Au bon moment du processus de commande, le client voit une suggestion pertinente s\'afficher, ce qui augmente sensiblement la valeur moyenne des commandes.' },
      { q: 'La borne peut-elle être connectée à mon système de caisse ?', a: 'Oui. Le Bistroo Kiosk s\'intègre avec tous les systèmes de caisse courants. Les commandes transitent automatiquement vers votre cuisine ou votre caisse, sans intervention manuelle.' },
      { q: 'Comment gérer le menu sur la borne ?', a: 'Le menu sur la borne est toujours synchronisé avec le Bistroo Manager. Modifiez un prix, désactivez un produit ou ajoutez une promotion et la borne l\'affiche immédiatement.' },
      { q: 'Quel est le coût du Bistroo Kiosk ?', a: 'Les coûts comprennent la location ou l\'achat du terminal matériel, plus un abonnement logiciel mensuel. Contactez-nous via bistroo.nl pour un devis personnalisé adapté à votre situation.' },
      { q: 'Quel chiffre d\'affaires supplémentaire une borne génère-t-elle en moyenne ?', a: 'Les restaurants qui introduisent le Bistroo Kiosk constatent en moyenne jusqu\'à 25 % de chiffre d\'affaires supplémentaire par commande. Les clients prennent plus de temps pour commander et sont plus enclins à choisir des extras lorsqu\'ils ne subissent pas la pression d\'une file d\'attente.' },
    ],
  },
}
